(function () {
  function init(root) {
    if (!root || root.dataset.mtAthleteReady === 'true') return;
    root.dataset.mtAthleteReady = 'true';

    var form = root.querySelector('.mt-athlete__form');
    var success = root.querySelector('[data-mt-athlete-success]');
    if (!form) return;

    form.addEventListener('submit', function (event) {
      if (!form.checkValidity()) return;
      event.preventDefault();
      form.classList.add('is-done');
      if (success) success.classList.add('is-visible');

      var action = form.getAttribute('action') || window.location.pathname;
      var data = new FormData(form);
      fetch(action, {
        method: 'POST',
        body: data,
        headers: { Accept: 'application/json' }
      }).catch(function () {});
    });
  }

  function boot() {
    document.querySelectorAll('[data-mt-athlete]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-mt-athlete]');
    if (root) {
      root.dataset.mtAthleteReady = 'false';
      init(root);
    }
  });
})();
